import { AlertCircle, Check, Loader2 } from 'lucide-react'
import type { SaveStatus } from '@/contexts/SaveStatusContext'
import { Tooltip, TooltipContent, TooltipTrigger } from '../ui/Tooltip'

const STATUS_TOOLTIPS: Record<SaveStatus, string> = {
	idle: 'All changes saved',
	saving: 'Saving...',
	saved: 'All changes saved',
	error: 'Save error',
}

interface SaveStatusIndicatorProps {
	status: SaveStatus
}

export function SaveStatusIndicator({ status }: SaveStatusIndicatorProps) {
	return (
		<Tooltip>
			<TooltipTrigger asChild>
				<div
					className="toolbar-status-indicator"
					data-status={status}
				>
					{status === 'saving' ? (
						<Loader2 className="toolbar-icon animate-spin" />
					) : status === 'error' ? (
						<AlertCircle className="toolbar-icon" />
					) : (
						<Check className="toolbar-icon" />
					)}
				</div>
			</TooltipTrigger>
			<TooltipContent side="right">{STATUS_TOOLTIPS[status]}</TooltipContent>
		</Tooltip>
	)
}
